import React from 'react';

import AssetCartRequest from '@components/Map/AssetCartRequest/AssetCartRequest';
import LegendOokla from '@components/Map/LegendaOokla';

import { auth, map } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { legendMeasurementsOokla } from '@components/Map/LegendaOokla/constants';

import styles from './MapControls.module.scss';

const RightSideVerticalControls = () => {
	const mapState = useAppSelector(map);

	const {
		accessPermission,
	} = useAppSelector(auth);

	const {
		appliedOoklaFilters: {
			isOoklaInfo,
			measurementName,
			serviceLevelGood,
			serviceLevelVariable,
			serviceLevelNoService,
		},
	} = mapState;

	const isShownLegendOokla = isOoklaInfo
		&& (
			measurementName?.name === legendMeasurementsOokla.measurementRSRP
			|| measurementName?.name === legendMeasurementsOokla.measurementRSRQ
		)
		&& (serviceLevelGood || serviceLevelVariable || serviceLevelNoService);

	const {
		networkOperatorAssetEnquirer,
		assetConsumerAssetEnquirer,
	} = accessPermission;

	return (
		<div className={styles.rightSideVerticalControls}>
			{isShownLegendOokla && measurementName?.name
				&& <LegendOokla
					measurementName={measurementName.name}
					serviceLevelGood={serviceLevelGood}
					serviceLevelNoService={serviceLevelNoService}
					serviceLevelVariable={serviceLevelVariable}
				/>
			}
			{(networkOperatorAssetEnquirer || assetConsumerAssetEnquirer) && <AssetCartRequest />}
		</div>
	);
};

export default RightSideVerticalControls;
